export default __webpack_public_path__ + "static/media/248.f3375032.jpg";